import { render, staticRenderFns } from "./data_filter.vue?vue&type=template&id=53b71f96&scoped=true"
import script from "./data_filter.vue?vue&type=script&lang=js"
export * from "./data_filter.vue?vue&type=script&lang=js"
import style0 from "./data_filter.vue?vue&type=style&index=0&id=53b71f96&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b71f96",
  null
  
)

export default component.exports